import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import { WA_MESSAGES, openWhatsApp } from '../../../config/site';

const CHAMPIONS = [
  {
    id: 1,
    rank: 2,
    name: 'Priya Sharma',
    city: 'Delhi',
    state: 'NCR',
    avatar: '/assets/images/gen/avatar-ps.svg',
    game: 'Teen Patti Gold',
    amount: '₹8,45,000',
    date: '12 July 2026',
    quote: 'Twelve hands, one very good night. The payout hit my account before I got home.',
  },
  {
    id: 2,
    rank: 1,
    name: 'Rajesh Kumar',
    city: 'Mumbai',
    state: 'Maharashtra',
    avatar: '/assets/images/gen/avatar-rk.svg',
    game: 'Lightning Roulette',
    amount: '₹14,20,000',
    date: '19 July 2026',
    quote: "Started with ₹5,000 — now I'm the monthly champion. The WhatsApp desk talked me through limits the whole way.",
  },
  {
    id: 3,
    rank: 3,
    name: 'Amit Patel',
    city: 'Ahmedabad',
    state: 'Gujarat',
    avatar: '/assets/images/gen/avatar-ap.svg',
    game: 'Andar Bahar Royal',
    amount: '₹6,10,000',
    date: '4 July 2026',
    quote: 'Small stakes, strict rules, no chasing. That is the whole strategy and it took me to the podium.',
  },
];

const MEDALS = {
  1: { ring: 'from-[#FFF0B8] to-[#C4901A]', label: 'Champion', icon: 'Crown', height: 'lg:mt-0' },
  2: { ring: 'from-[#E8E8F0] to-[#8A8AA0]', label: 'Runner-up', icon: 'Medal', height: 'lg:mt-12' },
  3: { ring: 'from-[#F0B48A] to-[#9A5A2A]', label: 'Third place', icon: 'Award', height: 'lg:mt-16' },
};

const MonthlyChampionsSection = () => (
  <section className="relative overflow-hidden py-24">
    <span className="aurora right-[-8%] top-[10%] h-96 w-96 bg-royal-gold/25" aria-hidden="true" />

    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl text-center">
        <span className="badge-pill"><Icon name="Crown" size={13} /> July 2026 podium</span>
        <h2 className="mt-6 font-heading text-display font-bold text-white">
          This month&apos;s <span className="gold-text">champions</span>
        </h2>
        <p className="mt-4 text-body-lg text-white/60">
          Verified against payout receipts, published with permission. Every rupee below has already landed in a
          real bank account.
        </p>
      </div>

      <div className="perspective mt-16 grid items-end gap-7 lg:grid-cols-3">
        {CHAMPIONS.map((c) => {
          const medal = MEDALS[c.rank];
          return (
            <article key={c.id} className={`card-3d relative p-7 text-center ${medal.height}`}>
              <span
                className={`absolute -top-5 left-1/2 flex h-11 w-11 -translate-x-1/2 items-center justify-center rounded-full bg-gradient-to-br ${medal.ring} shadow-[0_12px_26px_-12px_rgba(0,0,0,0.95)]`}
              >
                <Icon name={medal.icon} size={20} color="#150F02" />
              </span>

              <p className="mt-3 font-display text-[0.62rem] uppercase tracking-[0.22em] text-royal-gold">
                {medal.label}
              </p>

              <div className="relative mx-auto mt-4 h-20 w-20">
                <span className="absolute inset-0 animate-spin-slow rounded-full border border-dashed border-royal-gold/40" />
                <Image src={c.avatar} alt={c.name} className="h-20 w-20 rounded-full p-1" />
              </div>

              <h3 className="mt-4 font-heading text-xl font-bold text-white">{c.name}</h3>
              <p className="text-xs text-white/45">{c.city}, {c.state}</p>

              <div className="my-5 rounded-2xl border border-wa-green/25 bg-wa-green/8 px-4 py-3">
                <p className="text-[0.6rem] uppercase tracking-[0.18em] text-white/45">Won on {c.date}</p>
                <p className="mt-1 font-display text-2xl font-bold text-wa-green">{c.amount}</p>
                <p className="mt-0.5 text-xs text-white/50">{c.game}</p>
              </div>

              <blockquote className="text-sm italic leading-relaxed text-white/60">“{c.quote}”</blockquote>
            </article>
          );
        })}
      </div>

      <div className="panel-gold mt-14 px-6 py-10 text-center sm:px-12">
        <h3 className="font-heading text-2xl font-bold text-white">
          Next month&apos;s podium has <span className="gold-text">three empty seats</span>
        </h3>
        <p className="mx-auto mt-3 max-w-2xl text-white/60">
          Every champion here started with a single WhatsApp message and a modest first deposit. Ask the desk for
          the same coaching they got.
        </p>
        <button onClick={() => openWhatsApp(WA_MESSAGES.strategy)} className="btn-3d btn-3d-wa mt-7">
          <FaWhatsapp size={19} /> Start my winning journey
        </button>
      </div>
    </div>
  </section>
);

export default MonthlyChampionsSection;
